import React, { useState, useEffect } from 'react';
import t from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../shared/error_boundary'. 'app/webpack/javascripts/gdpr/components/shared/error_boundary.js' implicitly has an 'any' type.
import ErrorBoundary from '../shared/error_boundary';
import { ReadOnlyView } from './read_only_view';
import { EditView } from './edit_view';

import { standardRequestWithPendingFlash } from 'shared/utils/request';
// @ts-expect-error - TS7016 - Could not find a declaration file for module './validate_template'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/validate_template.js' implicitly has an 'any' type.
import { validateTemplate } from './validate_template';
import Flash from 'legacy/flash';
import $ from 'legacy/jquery';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/scrolling'. 'app/webpack/javascripts/shared/utils/scrolling.js' implicitly has an 'any' type.
import { scrollToClass } from 'shared/utils/scrolling';

type ConsentExtensionEmailData = {
  from: any;
  consent_period: number;
  body: string;
  subject: string;
  available_tokens: string[];
  available_from_emails: any[];
  submit_path: string;
  consent_email_validation_values_path: string;
  enable_consent_email_path: string;
  disable_consent_email_path: string;
  max_consent_period: number;
  enabled: boolean | null | undefined;
};

export function ConsentExtensionEmail(initialData: ConsentExtensionEmailData) {
  const [is_editing, setIsEditing] = useState(false);
  const [period, setConsentPeriod] = useState(initialData.consent_period);
  const [from, setFrom] = useState(initialData.from);
  const [body, setBody] = useState(initialData.body);
  const [subject, setSubject] = useState(initialData.subject);
  const [enabledEmails, setEnabledEmails] = useState(initialData.enabled);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    $(window.document).on('gdpr.openConsentExtensionEmail', () => {
      setIsEditing(true);
      scrollToClass('gdpr-consent-extension-email');
    });
  }, []);

  const editTemplateEvent = (editing: boolean): void => setIsEditing(editing);

  function save(formValues: any) {
    const validateTokensResult = validateTokens(
      formValues,
      initialData.available_tokens
    );

    if (validateTokensResult.isValid) {
      const transformedValues = getSaveablePayload(formValues);
      standardRequestWithPendingFlash
        .put(initialData.submit_path, { ...transformedValues })
        .then(() => {
          if (!!formValues) {
            setEnabledEmails(true);
            setConsentPeriod(+formValues.period);
            setFrom(formValues.from);
            setSubject(formValues.subject);
            setBody(formValues.body);
            setIsEditing(false);
          }
        });
    } else {
      Flash.setError(validateTokensResult.errorMessage);
    }
  }

  function validateTokens(formValues: any, available_tokens: Array<string>) {
    let isValid = false;
    let errorMessage = '';
    const uniqueInvalidTokens = new Set();

    const mergeTokens = (source: any, target: Set<any>) =>
      // @ts-expect-error - TS7006 - Parameter 'token' implicitly has an 'any' type.
      source.forEach((token) => target.add(token));

    const validationForBodyResult = validateTemplate(
      formValues.body,
      available_tokens
    );

    const validationForSubjectResult = validateTemplate(
      formValues.subject,
      available_tokens
    );

    if (!validationForBodyResult.isValid) {
      mergeTokens(validationForBodyResult.inValidTokens, uniqueInvalidTokens);
    }

    if (!validationForSubjectResult.isValid) {
      mergeTokens(
        validationForSubjectResult.inValidTokens,
        uniqueInvalidTokens
      );
    }

    errorMessage = `${t('gdpr.consent_extension_email.validation.tokens')}: ${[
      ...uniqueInvalidTokens,
    ].join(', ')}`;

    isValid =
      validationForBodyResult.isValid && validationForSubjectResult.isValid;

    return { isValid, errorMessage };
  }

  function getSaveablePayload(formValues: any) {
    return {
      consent_period: formValues.period,
      email_template: {
        html_body: formValues.body,
        subject: formValues.subject,
        from: formValues.from.value,
      },
    };
  }

  function saveConsentEmailEnabled(enabled: any) {
    const requestPath = enabled
      ? initialData.enable_consent_email_path
      : initialData.disable_consent_email_path;

    return standardRequestWithPendingFlash.put(requestPath);
  }

  if (is_editing) {
    return (
      <ErrorBoundary label={t('gdpr.consent_extension_email.title')}>
        <EditView
          period={period}
          from={from}
          body={body}
          subject={subject}
          froms={initialData.available_from_emails}
          tokens={initialData.available_tokens}
          setIsEditing={editTemplateEvent}
          save={save}
          initialErrors={errors}
          validationValuesPath={
            initialData.consent_email_validation_values_path
          }
        />
      </ErrorBoundary>
    );
  } else {
    return (
      <ReadOnlyView
        consentPeriod={period}
        consentEmailEnabled={!!enabledEmails}
        setConsentEmailEnabled={setEnabledEmails}
        saveConsentEmailEnabled={saveConsentEmailEnabled}
        setErrors={setErrors}
        setIsEditing={editTemplateEvent}
      />
    );
  }
}
